import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconCompany(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fill="currentColor"
        d="M14.5 13V5.5A.5.5 0 0 0 14 5h-4a.5.5 0 0 0-.5.5V8h-3V2.5A.5.5 0 0 0 6 2H2a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zm-4-7h3v7h-3zm-1 3v4h-3V9zm-7-6h3v10h-3zm2 1.5v1a.5.5 0 1 1-1 0v-1a.5.5 0 0 1 1 0m0 3v1a.5.5 0 1 1-1 0v-1a.5.5 0 0 1 1 0m0 3v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 1 0m3 1v-1a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0m4 0v-1a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0m0-3v-1a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0"
      />
    </SVGIcon>
  );
}
